import { DeprecatedGlobalAppV1Paths } from "@src/appV2/App/paths";
import { SelectableBox } from "@src/appV2/redesign/components/SelectableBox";

export function WorkplaceReferralCta() {
  return (
    <SelectableBox
      withCallToActionIcon
      href={DeprecatedGlobalAppV1Paths.WORKPLACE_REFERRALS}
      startIconType="building"
    >
      Refer a workplace and earn up to $1,000
    </SelectableBox>
  );
}
